import { flexibleChecksumsMiddleware, flexibleChecksumsMiddlewareOptions } from "./flexibleChecksumsMiddleware";
import { flexibleChecksumsResponseMiddleware, flexibleChecksumsResponseMiddlewareOptions } from "./flexibleChecksumsResponseMiddleware";
export var getFlexibleChecksumsPlugin = function getFlexibleChecksumsPlugin(config, middlewareConfig) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(flexibleChecksumsMiddleware(config, middlewareConfig), flexibleChecksumsMiddlewareOptions);
      clientStack.addRelativeTo(flexibleChecksumsResponseMiddleware(config, middlewareConfig), flexibleChecksumsResponseMiddlewareOptions);
    }
  };
};